var _path, _rect, _path2, _ellipse, _ellipse2, _path3, _ellipse3, _ellipse4, _path4, _ellipse5, _ellipse6, _path5, _ellipse7, _ellipse8, _path6, _path7, _path8, _path9, _path10, _ellipse9, _path11, _ellipse10, _ellipse11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1601,
    height: 594,
    viewBox: "0 0 1601 594",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1600 31.3228C1600 31.3228 1250.92 -7.43066 1146.78 2.7006C603.676 55.5403 0 31.3228 0 31.3228V343.984H1600V31.3228Z",
    fill: "#1A263E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.369141,
    y: 126.303,
    width: 1600,
    height: 466.95,
    fill: "url(#paint0_linear_3_366)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1211.8 27.442C1263.9 24.0154 1309.27 22.4345 1245.52 17.5117C1245.52 17.5117 1223.06 16.3216 1222.7 13.2169C1222.23 9.26586 1271.19 4.58274 1284.95 2.71001L1300.12 0.91622C1300.12 0.91622 1227.3 9.95626 1227.27 12.6761C1227.25 15.396 1241.77 15.9994 1250.6 16.6915C1277.28 19.7009 1324.93 21.9973 1211.97 28.8752C1029.34 39.9958 963.772 52.1604 933.086 58.2243C893.107 66.1249 918.911 70.2193 926.841 71.3749C934.77 72.5306 983.352 78.5979 1000.72 81.6498C1034.82 87.6412 1049.31 105.631 942.95 121.681C840.186 137.19 447.356 145.775 404.296 146.622C337.232 147.942 302.345 157.311 306.227 164.98C315.303 182.906 1120.44 214.993 1237.2 371.857L349.887 427.065C702.441 204.439 244.57 199.139 260.253 167.578C268.069 151.851 356.82 142.737 403.724 141.78C463.146 140.567 842.261 131.463 932.522 119.437C1047.11 104.169 1007.19 86.7414 995.563 84.8952C986.051 83.3843 944.65 76.3848 922.426 72.9111C910.733 71.0835 887.277 66.2765 928.408 57.7239C982.322 46.5129 1061.83 37.3057 1211.8 27.442Z",
    fill: "#293856"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 7.21713,
    ry: 15.1777,
    transform: "matrix(0.952491 -0.304568 0.326627 0.945153 608.827 261.632)",
    fill: "#0B1428"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.42454,
    ry: 15.1777,
    transform: "matrix(0.952491 -0.304568 0.326627 0.945153 617.081 257.182)",
    fill: "#0B1428"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M613.057 242.223L604.912 246.526L614.636 275.547L623.06 270.942L613.057 242.223Z",
    fill: "#0B1428"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 7.21713,
    ry: 15.1777,
    transform: "matrix(0.952491 -0.304568 0.326627 0.945153 648.266 237.846)",
    fill: "#0B1428"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.42454,
    ry: 15.1777,
    transform: "matrix(0.952491 -0.304568 0.326627 0.945153 654.551 234.673)",
    fill: "#0B1428"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M650.782 219.649L643.55 223.709L653.544 251.903L660.336 248.726L650.782 219.649Z",
    fill: "#0B1428"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.47257,
    ry: 9.97648,
    transform: "matrix(0.953446 -0.301564 0.331079 0.943603 561.716 238.074)",
    fill: "#0B1428"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.47257,
    ry: 9.97648,
    transform: "matrix(0.953446 -0.301564 0.331079 0.943603 568.013 234.895)",
    fill: "#0B1428"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M564.883 225.623L558.528 228.691L565.383 247.319L571.667 244.165L564.883 225.623Z",
    fill: "#0B1428"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 562.011,
    cy: 237.757,
    rx: 2.49778,
    ry: 5.46792,
    transform: "rotate(162.286 562.011 237.757)",
    fill: "#182944"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 608.441,
    cy: 262.54,
    rx: 3.74886,
    ry: 8.20669,
    transform: "rotate(162.286 608.441 262.54)",
    fill: "#182944"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M599.95 193.058L575.18 202.417L574.874 206.968C574.874 206.968 561.025 211.631 558.25 213.842C556.593 215.162 560.31 227.307 560.31 227.307L599.238 252.698L601.016 247.55L614.006 252.565L616.252 261.238L620.296 263.309L667.725 237.288L655.793 188.819L599.95 193.058Z",
    fill: "#3F5475"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M619.362 260.541L621.603 258.554L665.955 235.132L667.462 235.06L667.789 236.527L666.52 238.042L622.214 262.271L619.46 262.613L619.362 260.541Z",
    fill: "#0B1428"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M665.798 238.415L665.356 235.806L665.342 235.497L660.116 238.175L660.718 241.191L665.798 238.415Z",
    fill: "#9B0B13"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M629.066 258.33L628.591 255.561L628.576 255.232L622.932 258.08L623.58 261.28L629.066 258.33Z",
    fill: "#9B0B13"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M607.298 207.828C603.647 208.373 574.244 202.64 574.211 201.964C573.91 195.921 591.359 192.084 603.657 188.899C607.127 188 656.374 182.162 655.858 188.824C655.795 189.632 612.64 207.031 607.298 207.828Z",
    fill: "#788BA9"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 627.563,
    cy: 241.443,
    rx: 11.9257,
    ry: 13.9603,
    transform: "rotate(8.76019 627.563 241.443)",
    fill: "#14213C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M630.348 227.751L635.574 229.4L628.372 256.566L622.845 254.299L630.348 227.751Z",
    fill: "#14213C"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 631.713,
    cy: 242.934,
    rx: 11.0293,
    ry: 13.9603,
    transform: "rotate(8.76019 631.713 242.934)",
    fill: "#0B1428"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 632.883,
    cy: 243.144,
    rx: 5.28301,
    ry: 7.26909,
    transform: "rotate(8.76019 632.883 243.144)",
    fill: "#182944"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M632.61 205.277L619.169 210.825C618.246 211.206 617.746 212.209 617.996 213.175L621.463 226.56C621.783 227.799 623.169 228.422 624.308 227.84L637.448 221.131C638.283 220.705 638.71 219.756 638.475 218.848L635.309 206.625C635.005 205.449 633.732 204.814 632.61 205.277Z",
    fill: "#24304B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M641.229 216.188L638.249 204.68C638.003 203.731 638.481 202.744 639.378 202.349L650.204 197.578C651.333 197.081 652.638 197.713 652.947 198.907L655.832 210.046C656.072 210.972 655.622 211.938 654.76 212.351L644.029 217.49C642.894 218.034 641.545 217.406 641.229 216.188Z",
    fill: "#24304B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M607.284 212.64C608.402 212.787 609.444 212.793 610.354 212.689C611.718 212.533 613.364 213.243 613.708 214.572L616.988 227.238C617.23 228.172 616.776 229.164 615.853 229.442C612.437 230.473 609.101 229.751 607.415 228.418C607.117 228.182 606.947 227.829 606.874 227.456L604.51 215.274C604.212 213.74 605.735 212.435 607.284 212.64Z",
    fill: "#24304B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M658.713 208.804L655.421 196.095C655.257 195.46 655.414 194.784 655.843 194.287L656.918 193.041L660.082 206.087C660.336 207.133 659.992 208.233 659.189 208.949C659.026 209.094 658.768 209.015 658.713 208.804Z",
    fill: "#24304B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M575.422 217.101L576.517 207.063C576.584 206.456 577.174 206.05 577.765 206.204L582.449 207.431C582.824 207.529 583.108 207.835 583.179 208.217L585.379 220.11C585.521 220.879 584.765 221.506 584.035 221.224L576.056 218.142C575.633 217.979 575.373 217.552 575.422 217.101Z",
    fill: "#24304B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M600.21 212.165L588.042 209.171C587.338 208.998 586.69 209.607 586.819 210.32L588.872 221.699C588.935 222.044 589.173 222.331 589.5 222.456L602.141 227.276C602.872 227.556 603.626 226.923 603.479 226.154L600.953 212.949C600.88 212.565 600.589 212.259 600.21 212.165Z",
    fill: "#24304B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M552.627 221.925C553.6 220.924 559.916 218.805 559.916 218.805L570.546 223.487L576.586 237.341L599.255 251.977L597.803 252.824L572.649 240.903L571.397 241.419L564.919 229.683L555.57 225.563L552.74 226.296C552.74 226.296 551.165 223.429 552.627 221.925Z",
    fill: "#445B7E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_366",
    x1: 800.369,
    y1: 126.303,
    x2: 800.369,
    y2: 565.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A263E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#293856"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad);
export default __webpack_public_path__ + "static/media/road.fdb6c27314b003461769f55a60acf30e.svg";
export { ForwardRef as ReactComponent };